import {ChangeDetectorRef, Component, Input, OnInit} from "@angular/core";
import {Order} from "../../../shared/view-model/store-management/order.type";
import {ActivatedRoute} from "@angular/router";
import {ProcurementService} from "../../services/procurement-service/procurement.service";
import {AbstractVisbosComponent} from "../../../core/visbos-core/components/abstract-visbos.component";
import {SessionActions} from "../../../shared/actions/session.actions";
import {ApolloQueryObservable} from "apollo-angular";
import {MessageType} from "../../../shared/redux-store/session/session.types";
import {FileService} from "../../../core/visbos-core/http/file.service";

@Component({
  selector: 'vb-order-view',
  templateUrl: './order-view.component.html',
  styleUrls: ['./order-view.component.css']
})
export class OrderViewComponent extends AbstractVisbosComponent implements OnInit {

  @Input()
  order: Order;

  orderPdfLink: string;

  private order$: ApolloQueryObservable<any>;

  constructor(sessionActions: SessionActions, private route: ActivatedRoute,
              private procurementService: ProcurementService, private fileService: FileService, cd: ChangeDetectorRef) {
    super(sessionActions, cd);

    this.actions = [
      {
        label: 'PDF generieren',
        icon: 'fa-file-pdf',
        action: () => this.generatePDF.apply(this),
        helpText: "PDF für den Bestellschein generieren",
      }
    ];

  }

  ngOnInit() {

    this.orderPdfLink = null;

    this.dataSubscriptions.push(this.route.params.subscribe(params => {
        if (params.orderCuid) {
          this.loadOrder(params.orderCuid);
        }
      })
    );
  }

  private loadOrder(cuid: string) {

    if (!this.order$) {
      this.order$ = this.procurementService.loadOrder(cuid);
    } else {
      this.order$.setVariables({orderCuid: cuid});
    }

    this.dataSubscriptions.push(this.order$.subscribe(res => {
      this.order = res.data.order;
    }));
  }

  generatePDF() {

    if (!this.order) {
      return;
    }

    this.orderPdfLink = undefined;

    this.dataSubscriptions.push(
      this.procurementService.generateOrderPDF(this.order.cuid).subscribe(
        res => {
          //this.orderPdfLink = res.data.generateOrderPDF;
          let data = this.fileService.base64toBlob(res.data.generateOrderPDF, 'application/pdf', 512);
          this.fileService.saveAs(data, 'bestellung.pdf');
        }, err => {
          this.sessionActions.pushMessage("Fehler beim Generieren der PDF-Datei", MessageType.ERROR, "PDF-Erzeugung");
        })
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/procurement/order-view/order-view.component.ts